export default __webpack_public_path__ + "static/media/VIDT-BNB.d96c8fcd.svg";